import { Injectable } from '@angular/core';

import { Driver } from 'app/_models/drivers';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from './global-http.service';
import { PaginationParams } from '../_models/generic';
import { Utilities } from '../_utilities/Utilities';

@Injectable()
export class DriverService {
  data: any;

  constructor(private http: HttpClient) { }

  getDrivers(params: PaginationParams, unassigned=true, except=0): Observable<Driver[]> {
    const _params = Utilities.convertPaginationParameters(params);
    _params["unassigned"] = unassigned;
    if(except > 0) {
        _params["except"] = except;
    }
    return this.http.get<Driver[]>('/api/drivers_list/', { params: _params });
  }

  getDriver(id): Observable<Driver> {
    return this.http.get<Driver>('/api/driver/' + id + '/',);
  }

  putUpdateDriver(updateDriver: any, id: number) {
    const apiUpdateDriver = '/api/driver/' + id + '/';
    this.data = this.http.put(apiUpdateDriver, updateDriver);
    return this.data;
  }
}


// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/drivers.service.ts